export interface IDependantCodeListRequest {
  source: string;
  category: string;
  dependantCategory: string;
  codes: string[];
  localeId: string;
}
